import { getTrendingItems } from '@/redux/modules/home/home.selectors';
import { memo } from 'react';
import { useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import ItemShelf from '@/components/ItemShelf/ItemShelf';

type Props = {
    className?: string;
};

const TrendingItemsCarousel = ({ className }: Props) => {
    const { formatMessage } = useIntl();

    const itemIds = useAppSelector(getTrendingItems);

    return (
        <ItemShelf
            className={className}
            identifier="trendingItems"
            itemIds={itemIds}
            testid="trendingItemsCarousel"
            title={formatMessage({ id: 'trending_items' })}
        />
    );
};

export default memo<Props>(TrendingItemsCarousel);
